import React from 'react'

import classes from './AssignStatus.scss'

import { CardContent, Chip, withStyles } from '@material-ui/core'

const assignStatus = ({ structures }) => {
  const structureStatusBadges = structures.map(structure => {
    return <StructureChip structureData={structure} key={structure.structure_id} />
  })
  return <CardContent className={classes.StatusWrapper}>{structureStatusBadges}</CardContent>
}

const StructureChip = ({ structureData }) => {
  let color = structureData?.assigned ? 'primary' : 'secondary'

  return (
    <StyledChip
      label={structureData?.structure_name}
      variant={'outlined'}
      size={'small'}
      color={color}
    />
  )
}

const StyledChip = withStyles(theme => ({
  root: {
    margin: theme.spacing(0.5)
  },
  outlinedPrimary: {
    color: theme.palette.success.main,
    border: `1px solid ${theme.palette.success.main}`
  }
}))(Chip)

export default assignStatus
